/**
 * Componente contenedor de botones y controles para Forecast Metrics
 * Maneja el layout y organización de los controles de la vista
 */

import React from 'react';
import { Box, colors } from '@mui/material';
import AutocompleteCqlFecha from './buttons_cqlFecha.js';
import AutocompleteLayersGeoserver from './buttons_layersAI.js';
import AutocompleteIssueTimestamp from './buttons-issueTime.js';
import AutocompleteIssueTimestampHours from './buttons-issueTime_hours.js';

/**
 * Contenedor de botones para la vista Forecast Metrics
 * @param {Object} props - Propiedades del componente
 * @returns {JSX.Element} Componente de contenedor de botones
 */
const ForecastButtonsContainer = ({
  cqlFecha,
  selectedModel,
  cqlFechaMax,
  cqlFechaMin,
  issueTimeOptions,
  issueTime,
  onDateChange,
  onModelClick,
  onDateSelect,
  onTimeSelect,
  onBackdropOpen,
  onBackdropClose,
  setIssueTimeOptions,
  layout = 'full', // 'full' o 'simple'
}) => {


  const containerStyles = {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' },
    alignItems: 'start',
    justifyContent: 'stretch',
    width: '100%',
    gap: 0.75,
  
    overflow: 'visible',
    whiteSpace: 'normal',

    '& .MuiFormControl-root': {
      '& .MuiInputBase-root': {
        height: 36,
        fontSize: '0.875rem',
        backgroundColor: '#161616',
        
        color: { xs: '#f4f7f4', sm: 'transparent', lg: '#fcfffc' },

        '& .MuiInputBase-input': {
          padding: '8px 12px',
          color: 'inherit',
          WebkitTextFillColor: 'inherit',
          
        },

        '& .MuiSvgIcon-root': {
          color: '#fff',
        }
      },

      '& .MuiInputLabel-root': {
        display: { xs: 'block', sm: 'none', lg: 'block' },
        // --- COLOR DE LA ETIQUETA (Select Date, AI Model) ---
        color: '#ffffffd6',
        fontSize: '0.875rem',
        fontWeight: 600,
        transform: 'translate(14px, 9px) scale(1)',
        '&.MuiInputLabel-shrink': {

          transform: 'translate(14px, -15px) scale(0.75)',
          color: '#ffffff',

        }
      },

      '& .MuiOutlinedInput-root': {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#1565c0',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#1976d2',
        }
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#14599e',
        borderRadius: '12px', // Asegúrate de que coincida con el root
        '& legend': {
          // Si no quieres el "hueco" oficial, podemos ocultarlo 
          // y dejar que el fondo de la etiqueta haga el trabajo
          width: '0px',
        }
      }
    },
  };

  const controlStyles = {
    minWidth: '0',
    width: '100%',

    '& .MuiAutocomplete-root': {
      width: '100%',

      '& .MuiOutlinedInput-root': {
        

      }
    },
    '& .MuiFormControl-root': {
      width: '100%',

    }
  };

  if (layout === 'simple') {
    return (
      <Box sx={{
        ...containerStyles,
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}>
        <Box sx={controlStyles}>
          <AutocompleteCqlFecha cqlFecha={cqlFecha} handleDateChange={onDateChange} />
        </Box>
        <Box sx={controlStyles}>
          <AutocompleteLayersGeoserver selectedModel={selectedModel} handleModelClick={onModelClick} />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{
      ...containerStyles
    }}>
      <Box sx={controlStyles}>
        <AutocompleteCqlFecha cqlFecha={cqlFecha} handleDateChange={onDateChange} />
      </Box>
      <Box sx={controlStyles}>
        <AutocompleteLayersGeoserver selectedModel={selectedModel} handleModelClick={onModelClick} />
      </Box>
      <Box sx={controlStyles}>
        <AutocompleteIssueTimestamp
          handleDateSelect={onDateSelect}
          cqlFechaMax={cqlFechaMax}
          cqlFechaMin={cqlFechaMin}
          handleBackdropOpen={onBackdropOpen}
          handleBackdropClose={onBackdropClose}
          setIssueTimeOptions={setIssueTimeOptions}
          selectedModel={selectedModel}
        />
      </Box>
      <Box sx={controlStyles}>
        <AutocompleteIssueTimestampHours
          issueTimeOptions={issueTimeOptions}
          issueTime={issueTime}
          handleTimeSelect={onTimeSelect}
          selectedModel={selectedModel}
        />
      </Box>
    </Box>
  );
};

export default ForecastButtonsContainer;
